import * as React from 'react';

import useSponsorAdsBanner from 'data/queries/useSponsorAdsBanner';
import * as style from 'styles/components/homepage/sponsorAds.module.scss';

const SponsorAdsBanner = () => {
    const sponsorAds = useSponsorAdsBanner();

    return (
        <div className={`wrapper ${style.sponsorAds}`}>
            {sponsorAds.map((item, index) => (
                <a
                    key={index}
                    href={item.url}
                    target={item.external ? '_blank' : null}
                    rel="noreferrer"
                >
                    <img src={item.image.asset.url} alt={item.alt} />
                </a>
            ))}
        </div>
    );
};

export default SponsorAdsBanner;
